<script lang="ts">
  import type { FormField } from '../types';
  import { resetField } from '$lib/helpers/form-field-reset';

  export let field: FormField;
  export let selectedValue: string;
  export let isError: boolean = false;

  function handleReset() {
    selectedValue = '';
  }
</script>

<div class:isError>
  {#if field.label}
    <label for={field.id}>{field.label}</label>
  {/if}
  <select
    class="fs-exclude"
    id={field.id}
    name={field.id}
    title={field.validationMessage}
    required={field.required}
    use:resetField
    on:reset={handleReset}
    bind:value={selectedValue}
  >
    {#each field.selectOptions as selectOption}
      <option
        disabled={selectOption.selected === true}
        selected={selectOption.selected === true}
        value={selectOption.value}
      >
        {selectOption.label}
      </option>
    {/each}
  </select>
</div>

<style lang="scss">
  div {
    select {
      cursor: pointer;

      display: block;
      overflow: hidden;
      width: 100%;
      height: 50px;
      padding: calc((50px - var(--line-height-28)) / 2) calc((50px - var(--font-size-16)) / 2);
      padding-right: 48px;
      font-size: var(--font-size-16);
      line-height: var(--line-height-28);
      font-weight: var(--font-weight-base);
      color: var(--color-input-text);
      background-color: var(--color-white);
      border-radius: 5px;
      box-shadow: inset 0 0 0 1px var(--color-gray-55);

      transition:
        box-shadow var(--duration-quick) var(--easing-sharp),
        background-color var(--duration-quick) var(--easing-sharp),
        opacity var(--duration-quick) var(--easing-sharp);

      background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0Ij4KICA8cGF0aCBkPSJNMSA1bDYgNiA2LTYiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzFhMWExYSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      background-repeat: no-repeat;
      background-position: calc(100% - calc((50px - var(--font-size-16)) / 2)) 18px;

      &:focus {
        box-shadow: inset 0 0 0 2px var(--color-blue);
      }
    }
    &.isError {
      select {
        box-shadow: inset 0 0 0 1px var(--color-red);
        background-image:
          url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0Ij4KICA8cGF0aCBkPSJNMSA1bDYgNiA2LTYiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzFhMWExYSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo='),
          url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjdHJpYW5nbGUtd2FybmluZy1yZWRfc3ZnX19jbGlwMCkiIGZpbGw9IiNkZjMzMjAiPgogICAgPHBhdGggZD0iTTIyLjgxMyAxOS4xMDVsLS44Ni41MDkuMDA4LjAxMy44NTItLjUyMnpNMTMuMDY1IDIuNjE2bC44Ni0uNTA5YTMuOTk1IDMuOTk1IDAgMCAwLS4wMDgtLjAxM2wtLjg1Mi41MjJ6bS0yLjEzOSAwbC44NjEuNTA5YTEuMDMgMS4wMyAwIDAgMCAuMDItLjAzN2wtLjg4LS40NzJ6TTEuMTc4IDE5LjEwNWwuODUzLjUyMmEuNjguNjggMCAwIDAgLjAwOC0uMDEzbC0uODYxLS41MXpNMTEgMTNhMSAxIDAgMSAwIDIgMGgtMnptMi00YTEgMSAwIDEgMC0yIDBoMnpNMi4yNDcgMjJoMTkuNDk3di0ySDIuMjQ3djJ6bTE5LjQ5NyAwYzEuODA3IDAgMi44MjMtMS45NDcgMS45MjItMy40MThsLTEuNzA2IDEuMDQ1YS4yNC4yNCAwIDAgMSAuMDA5LjI1LjIzMi4yMzIgMCAwIDEtLjA4Mi4wODguMjY2LjI2NiAwIDAgMS0uMTQzLjAzNXYyem0xLjkzLTMuNDA0TDEzLjkyNiAyLjEwN2wtMS43MjIgMS4wMTggOS43NDggMTYuNDg5IDEuNzIyLTEuMDE4ek0xMy45MTggMi4wOTRjLS44NjYtMS40MTQtMy4wMzItMS41Mi0zLjg3My4wNWwxLjc2My45NDRhLjE0OC4xNDggMCAwIDEgLjA2LS4wNjMuMjE1LjIxNSAwIDAgMSAuMTA0LS4wMjVjLjA5MSAwIC4xODIuMDQzLjI0LjEzOGwxLjcwNi0xLjA0NHptLTMuODUyLjAxM0wuMzE3IDE4LjU5NmwxLjcyMiAxLjAxOCA5Ljc0OC0xNi40OS0xLjcyMS0xLjAxN3pNLjMyNiAxOC41ODJDLS42IDIwLjA5MS41NDUgMjIgMi4yNDYgMjJ2LTJjLS4wNzEgMC0uMTUzLS4wMzgtLjIwOS0uMTM2LS4wNTMtLjA5NC0uMDQ1LS4xNzUtLjAwNy0uMjM3TC4zMjUgMTguNTgyek0xMyAxM1Y5aC0ydjRoMnoiLz4KICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTciIHI9IjEiLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9InRyaWFuZ2xlLXdhcm5pbmctcmVkX3N2Z19fY2xpcDAiPgogICAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDI0djI0SDB6Ii8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg==');
        background-position: calc(100% - 17px), calc(100% - 20px), 18px, 13px;
        background-repeat: no-repeat;

        &:focus {
          box-shadow: inset 0 0 0 2px var(--color-red);
        }
      }
      label {
        color: var(--color-red);
      }
    }
  }
</style>
